export interface FiltersState {
  search: string;
}

export const initialFiltersState: FiltersState = {
  search: '',
};
